import React, { useContext, useState, useEffect } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import PercentSlider from "./../Controls/Slider/PercentSlider";
import { Button } from "react-bootstrap";

const EstimatedPurchase: React.FunctionComponent<{
  onSubmit?: (value: number[]) => void;
}> = (props: { onSubmit?: (value: number[]) => void }) => {
  const loanFormContext = useContext(LoanFormContext);
  const [lowerBound, setLowerBound] = useState<number>(10);
  const [upperBound, setUpperBound] = useState<number>(15);

  useEffect(() => {
    if (loanFormContext.downPayment) {
      setLowerBound(loanFormContext.downPayment.value.value);
      setUpperBound(loanFormContext.downPayment.value.upperBound);
    }
  }, [loanFormContext.estimatedPruchase]);

  const handleSubmit = () => {
    if (props.onSubmit) props.onSubmit([lowerBound, upperBound]);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            How much are you putting down as a down payment?
          </h1>
        }
      >
        <div className="form-inputs-wrapper">
          <PercentSlider
            value={lowerBound}
            onChange={(e) => {
              setLowerBound(e[0]);
              setUpperBound(e[1]);
            }}
          />
          <div className="mt-5">
            <Button variant="primary" block onClick={handleSubmit}>
              Continue
            </Button>
          </div>
        </div>
      </FormStep>
    </div>
  );
};

export default EstimatedPurchase;
